export default __webpack_public_path__ + "static/media/leftArrow.ca7e5505.svg";